import { GLN } from 'interfaces/global/gln'

export const brandLogoMapper: Record<GLN, JSX.Element> = {
	[GLN.SS]: <img src="/images/brands/ss-full.jpg" alt="Vörumerki SS" />,
	[GLN.REYKJAGARDUR]: <img src="/images/brands/hollta-large.jpg" alt="Vörumerki Holta" />,
	[GLN.HOLLTOGGOTT]: <img src="/images/brands/holtoggott.png" alt="Vörumerki Hollt og Gott" />,
}
